import { Layout, BusFile as BusFileComponent } from "components"
export const BusFile = () => {
 return (
  <Layout>
   <BusFileComponent />
  </Layout>
 )
}
